import CryptoJS from "crypto-js";

export default {
  encrypt: function (data) {
    /* AES前端加密 */
    var key = CryptoJS.enc.Utf8.parse("zkcmkjyxgs201907");
    var iv = CryptoJS.enc.Utf8.parse("zkcmsuzhougongsi");
    var str = CryptoJS.AES.encrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding,
    }).toString();
    return this.filter(str);
  },
  filter: function (value) {
    value = value
      .replace("#", "%23")
      .replace("%", "%25")
      .replace("&", "%26")
      .replace("+", "%2B")
      .replace("//", "%2F")
      .replace("?", "%3F");
    return value;
  },
};
